import { render, staticRenderFns } from "./VentanaOperacionIndex.vue?vue&type=template&id=3bfb0cd4"
import script from "./VentanaOperacionIndex.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports